// extracted by mini-css-extract-plugin
export default {"gray":"At5a9LBzQyDImGjhexsW","green":"xlg2KctPwP96hUkgBUOZ","red":"NGl6bIAemn1VDUrOKw5P"};